import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appRequiredBorder]'
})
export class RequiredBorderDirective {

  @Input() redBorder!: boolean;
  constructor(private el: ElementRef) {}

  // @HostListener('blur') onBlur() {
  //   const input = this.el.nativeElement;
  //   if (input.required && !input.value) {
  //     input.classList.add('border-red');
  //   } else {
  //     input.classList.remove('border-red');
  //   }
  // }
  ngOnInit() {
    if (this.redBorder) {
      this.el.nativeElement.classList.add('border-red');
    }
  }
}
